import { render, staticRenderFns } from "./ProductDesignSubmitView.vue?vue&type=template&id=5b55115f&"
import script from "./ProductDesignSubmitView.vue?vue&type=script&lang=js&"
export * from "./ProductDesignSubmitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports